<template>
  <div>
    <!-- TODO: set 'is_disabled' based on filter -->
    <draggable
      :key="`${step_type}steps${workpackage_id}`"
      animation="300"
      forceFallback="true"
      fallbackOnBody="true"
      :disabled="!isEditMode"
      :value="wp[`t${step_type.toLowerCase()}steps`]"
      @end="$emit('draggableEnd', $event)"
      >
      <ClickableListItem
        v-for="(step, index) in steps"
        :key="`stepitem${index}-${step.id}`"
        :id="step.id"
        :is_selected="step.id === $route.params.content_id"
        :is_disabled="false"
        :has_lines="has_lines"
        :is_first="index == 0"
        :background_color="background_color"
        :foreground_color="foreground_color"
        @emittedClick="$emit('clickStepList', step.id)"
      >
        <!-- CLICKABLE LIST SLOTS -->
        <template #front>
          <RadialCheckbox
            :id="step.id"
            :is_checked="step_type === 'Material'?(step.status === 'done'):step.done"
            :background_color="background_color"
            :foreground_color="foreground_color"
            @setActive="$emit('clickStepDone', {step: step, step_id: step.id, set_to: step_type === 'Material'?(step.status === 'done'?'open':'done'):!step.done})"
          />
        </template>

        <template #descriptor>
          <StepDescriptor
            :step_name="step.text"
            :properties="getStepLinks(step)"
            :total="calcStepTotal(step, step_type, false, prefix)"
            :background_color="background_color"
            :foreground_color="foreground_color"
            :key="`${calcStepTotal(step, step_type, false, prefix).value}`"
          />
        </template>
        <template #info>
          <div
            v-if="!['Work', 'Material', 'Machine'].includes(step_type)"
            style="white-space: nowrap"
          >
            {{ step.offset }} TT
          </div>
          <div
            v-else-if="['Machine'].includes(step_type)"
          >
            {{ step.booking_value }}
            {{ step.booking_unit }}
            {{ step.type }}
        </div>
        </template>
      </ClickableListItem>
    </draggable>
  </div>
</template>

<script>

import draggable from "vuedraggable";
import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
// import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';

import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import RadialCheckbox from '@/components/WorkPackageWIP/RadialCheckbox.component.vue';
import StepDescriptor from '@/modules/WorkPackageWIP/StepDescriptor.module.vue';

  export default {
    components: {
      ClickableListItem,
      RadialCheckbox,
      StepDescriptor,

      draggable,
    },

    mixins: [
      WorkPackageReworkMixin,
      // WorkPackageWIPMixin,
    ],

    props: [
      'steps', // is array of objects, contains id, name (string), is_checked (boolean), image_count, element_count, material_step_count
      'type', // is string, contains type of step type
      'has_lines', // is boolean, deactivates first line draw
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'step_type',
      'backlog',
      'prefix',
      'wp'
    ],

    data: () => ({
      // selected_id: -1,
    }),
    methods: {
      getStepLinks(step) {
        let links = [];
        if (step.tworkpackageimages && step.tworkpackageimages.length > 0) {
          links.push({ name: 'images', value: step.tworkpackageimages.length, icon: 'image' });
        }
        if (step.elements && step.elements.length > 0) {
          links.push({ name: 'elements', value: step.elements.length, icon: 'cube' });
        } else if (step.elements_count > 0) {
          links.push({ name: 'elements', value: step.elements_count, icon: 'cube' });
        }
        if (step.tmaterialsteps && step.tmaterialsteps.length > 0) {
          links.push({ name: 'material steps', value: step.tmaterialsteps.length, icon: 'wall-brick' });
        }
        return links;
      },
      // handleClick(step) {
      //   console.log(`${origin} got selected!`);
      //   this.selected_id = step.id;
      //   this.$emit('clickStepList', step.id);
      // },
      //
      // resetSelectedId() {
      //   this.selected_id = -1;
      // },
      //
      // log(string, is_selected) {
      //   console.log(`${string} got ${is_selected ? 'selected' : 'deselected'}!`);
      // },
    },
  }
</script>

<style>

</style>
